import { store } from 'stores/Store';
import styles from './RoutesTab.module.scss';
import { createSearchParams, useNavigate } from 'react-router-dom';

interface IRoutesTab {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onSelect: (opt: string) => void;
  onPractitionerAdded?: () => void;
}

const RoutesTab = ({ isOpen, setIsOpen, onSelect, onPractitionerAdded }: IRoutesTab) => {
  const navigate = useNavigate();
  const defaultAddress = store?.currentPractitioner?.addresses
    ?.find((a: any) => a.id === store?.currentPractitioner?.default_address);
  const isGeoValidated = defaultAddress?.latitude && defaultAddress?.longitude;

  return (
    <div style={{ display: isOpen ? 'block' : 'none', zIndex: 4000 }}>
      <div 
        className={styles.overlay} 
        onClick={() => setIsOpen(false)}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 5002,
          height: '300%',
          width: '100%',
        }}
      />
      <div className={styles.optsWrapper}>
        <div style={{
          maxHeight: '400px',
          overflowY: 'auto'
        }}>
          <div className={styles.headerWrapper}>
            <p style={{ fontSize: '16px', fontWeight: '500', textAlign: 'center' }}>Open route in:</p>
          </div>

          <button
            className={styles.btn}
            onClick={() => onSelect('google')}
          >
            <p className={styles.smallText}>Google Maps</p>

          </button>
          <button
            className={styles.btn}
            onClick={() => onSelect('waze')}
          >
            <p className={styles.smallText}>Waze</p>
          </button>
          <button
            className={styles.btn}
            onClick={() => onSelect('apple')}
          >
            <p className={styles.smallText}>Apple Maps</p>
          </button>
          {isGeoValidated && (
            <button
              className={styles.btn}
              onClick={() => {
                navigate({
                  search: createSearchParams({
                    lat: defaultAddress?.latitude + "",
                    lon: defaultAddress?.longitude + "",
                    id: store?.currentPractitioner?.id + "",
                    }).toString(),
                  pathname: "/mapView"
                });
              }}
            >
              <p className={styles.smallText}>Find on Map</p>
            </button>
            
          )}
          {isGeoValidated && (
            <button
              className={styles.btn}
              onClick={() => {
                store.addToRoute(store.currentPractitioner);
                setIsOpen(false);
                onPractitionerAdded?.();
              }}
            >
              <p className={styles.smallText}>Add to route</p>
            </button>
          )}
          {/*
        <button
          className={styles.btn}
          onClick={() => onSelect('website')}
        >
          WEBSITE
          <p className={styles.smallText}>{store.currentPractitioner?.website}</p>
        </button>
        */}
        </div>
      </div>

      <div className={styles.cancelWrapper}>
        <button
          onClick={() => setIsOpen(false)}
          style={{
            background: 'none',
            color: '#000',
            fontSize: '17px',
            margin: '5px',
            borderRadius: '10px',
            border: 'none'
          }}
        >
          CANCEL
        </button>
      </div>
    </div>
  );
};

export default RoutesTab;
